<template>
  <div class="gh-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <div class="card-title">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="公海客户" name="first"></el-tab-pane>
              <el-tab-pane label="死海列表" name="second"></el-tab-pane>
            </el-tabs>
            <div class="search-mode">
              <input type="text" class="search-input" @keyup.enter="Search" placeholder="关键字搜索" v-model="search" />
              <el-button class="search-btn" icon="el-icon-search" @click="Search"/>
            </div>
          </div>
          <div class="card-content" v-loading="loading">
            <div style="width: 100%;text-align: center;padding: 50px 0;" v-if="!loading&&total<=0">
              <i class="el-icon-document-copy" style="font-size: 5rem;color:rgb(203, 226, 252);"></i>
              <p style="color: #909399">暂无客户数据</p>
            </div>
            <div class="client-list" v-if="total>0">
              <div class="client-item" v-for="c in tableData" @click="openDetails(c)">
                <div class="name">
                  <span>{{c.name}}</span>
                  <svg-icon icon-class="client_man" class="client-sex" v-if="c.sex === 1"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="c.sex === 0" />
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-medal"></i> 客户等级</div>
                  <div class="txt" style="padding-top: 8px"><el-rate v-model="c.level" disabled-void-color="#ffffff" disabled></el-rate></div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-mobile-phone"></i> 联系电话</div>
                  <div class="txt">{{c.tel}}</div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-map-location"></i> 所在地区</div>
                  <div class="txt">{{c.province}} {{c.city}} {{c.county}}</div>
                </div>
                <div class="info-box" v-if="type==1">
                  <div class="label"><i class="el-icon-timer"></i> 前跟进人</div>
                  <div class="txt">{{c.followname}}</div>
                </div>
                <div class="info-box">
                  <div class="label"><i class="el-icon-timer"></i> {{type===1?'回归':'置入'}}时间</div>
                  <div class="txt">{{c.followtime}}</div>
                </div>
              </div>
            </div>
            <el-pagination
              v-if="total>0"
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :visible.sync="viewVisible"
      title="客户档案"
      width="70%"
      top="10vh"
      :destroy-on-close="true"
      :lock-scroll="true"
      custom-class="khgl-client-detail"
      :append-to-body="true">
      <div class="view-box" v-loading="viewLoading">
        <el-row>
          <el-col :span="8">
            <el-card class="base-info" shadow="never">
              <div slot="header" class="tit">
                <span>基本资料</span>
                <el-button v-if="clientDetail.mark===1" size="mini" style="float: right;margin-top: -3px;margin-left: 10px" @click="followClient" :loading="followEditLoading" type="primary">我来跟进</el-button>
                <el-button v-if="clientDetail.mark===0&&clientDetail.isall" size="mini" style="float: right;margin-top: -3px;margin-left: 10px" :loading="followEditLoading" @click="putSeas" type="primary">放回公海</el-button>
                <el-dropdown v-if="clientDetail.isall" trigger="click" placement="bottom" :key="forwardKey" class="client-info-dropdown">
                  <el-button size="mini">移交给 <i class="el-icon-caret-bottom"></i></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="u in clientDetail.forwardlist" @click.native="forwardC(u)"><el-avatar :src="u.photourl" style="margin-right: 8px;width: 22px;height: 22px;line-height: 22px;float: left;margin-top: 7px"></el-avatar>{{u.dName}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="text">
                <div class="l">
                  <span class="label">客户姓名:</span>
                  <span class="name">{{clientDetail.name}}</span>
                  <svg-icon icon-class="client_man" class="client-sex" v-if="clientDetail.sex === 1"/>
                  <svg-icon icon-class="client_women" class="client-sex" v-if="clientDetail.sex === 0" />
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户等级:</span>
                  <el-rate style="float: left" v-model="clientDetail.level" disabled-void-color="#ffffff" disabled></el-rate>
                </div>
                <div class="l">
                  <span style="float: left" class="label">联系电话:</span>
                  <span>{{clientDetail.tel}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户微信:</span>
                  <span>{{clientDetail.wchat!==null&&clientDetail.wchat!==undefined&&clientDetail.wchat!==''?clientDetail.wchat:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">所在地区:</span>
                  <span>{{clientDetail.province}} {{clientDetail.city}} {{clientDetail.county}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">线下门店:</span>
                  <span>{{clientDetail.shop!==null&&clientDetail.shop!==undefined&&clientDetail.shop!==''?clientDetail.shop:'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">门店面积:</span>
                  <span>{{clientDetail.area!==null&&clientDetail.area!==undefined&&clientDetail.area!==''&&clientDetail.area>0?clientDetail.area+' m²':'N/A'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户来源:</span>
                  <span>{{clientDetail.source===1?'第三方平台':clientDetail.source===2?'招商会':clientDetail.source===3?'异业介绍':clientDetail.source===4?'地推':clientDetail.source===5?'商场推荐':clientDetail.source===6?'数字名片':'其他'}}</span>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户状态:</span>
                  <el-tag type="danger" :disable-transitions="true" size="mini" v-if="clientDetail.mark===1">回归公海</el-tag>
                  <el-tag type="info" :disable-transitions="true" size="mini" v-if="clientDetail.mark===0">置入死海</el-tag>
                </div>
                <div class="l">
                  <span style="float: left" class="label">客户备注:</span>
                  <span>{{clientDetail.remark!==null&&clientDetail.remark!==undefined&&clientDetail.remark!==''?clientDetail.remark:'N/A'}}</span>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="16" style="padding-left: 20px">
            <div style="margin-bottom: 15px">
              <span style="font-size: 14px;font-weight: 500;color: #303133;">跟进记录</span>
            </div>
            <div class="follow-list" v-loading="followLoading">
              <div class="follow-item" v-for="f in followList">
                <div  class="follow-userinfo" v-if="f.username===null||f.username===undefined||f.username===''">
                  <el-avatar class="photo" shape="square" :size="50" :src="elichain_photo"></el-avatar>
                  <div class="name">慕鹿助手<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                  <div class="time">{{f.time}}</div>
                </div>
                <div class="follow-userinfo" v-if="f.username!==null&&f.username!==undefined&&f.username!==''">
                  <el-avatar class="photo" shape="square" :size="50" :src="f.photourl"></el-avatar>
                  <div class="name">{{f.username}}<el-tag size="mini" :type="f.type===0?'danger':f.way==='客户录入'?'':'warning'">{{f.way}}</el-tag></div>
                  <div class="time">{{f.time}}</div>
                </div>
                <div class="follow-content" v-if="f.content!==null&&f.content!==undefined&&f.content!==''">{{f.content}}</div>
                <div class="follow-imgs" v-if="f.imgurlarr.length>0">
                  <el-image
                    v-for="img in f.imgurlarr"
                    fit="cover"
                    class="follow-img"
                    :src="img"
                    :preview-src-list="f.imgurlarr"
                  />
                </div>
              </div>
<!--              <div class="follow-item">-->
<!--                <div class="follow-userinfo">-->
<!--                  <el-avatar class="photo" shape="square" :size="50" :src="clientDetail.createphoto"></el-avatar>-->
<!--                  <div class="name">{{clientDetail.createname}}<el-tag size="mini">客户录入</el-tag></div>-->
<!--                  <div class="time">{{clientDetail.createtime}}</div>-->
<!--                </div>-->
<!--                <div class="follow-content">-->
<!--                  由&nbsp;<span style="color: #409EFF">{{clientDetail.createdept}}-{{clientDetail.createname}}</span>&nbsp;录入此客户</span>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { followPublicClient, forwardClient, getClentFollowList, getClientDetail, getPublicClient, putPublicClientToSeas } from '@/api/work'
import { formatDate } from '@/api/pub'
import elichain_photo from '@/assets/elichain_photo.jpg'

export default {
  name: 'gh',
  computed: {
    user: getUser
  },
  data() {
    return {
      activeName: 'first',
      search: '',
      type: 1,
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      viewVisible: false,
      viewLoading: false,
      clientDetail: {
        areadealerlst: []
      },
      followList: [],
      followLoading: false,
      forwardKey: '',
      elichain_photo: elichain_photo,
      followEditLoading: false
    }
  },
  created() {
    this.getData()
  },
  methods: {
    handleClick(tab, event) {
      let _type = 1
      if (tab.index == 1) {
        _type = 0
      }
      if (_type === this.type) {
        return
      }
      this.type = _type
      this.currentPage = 1
      this.getData()
    },
    Search() {
      if (this.search != null && this.search.trim() != '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        type: this.type,
        content: this.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid
      }
      getPublicClient(data).then(response => {
        this.loading = false
        let _tableData = response.data
        for (let t of _tableData) {
          t.followtime = formatDate(Date.parse(t.followtime))
        }
        this.tableData = _tableData
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.forwardKey = new Date().getTime()
      this.followList = []
      this.viewVisible = true
      this.viewLoading = true
      const data = {
        userid: this.user.dUserid,
        clientid: row.cid,
        groupid: this.user.dGroupid
      }
      getClientDetail(data).then(response => {
        this.clientDetail = response.data
        this.clientDetail.createtime = formatDate(Date.parse(this.clientDetail.createtime))
        this.viewLoading = false
        this.getFollowList()
      }).catch(() => {
        this.viewLoading = false
      })
    },
    followClient() {
      if (!this.followEditLoading) {
        this.$confirm('此客户将由我来跟进, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.followEditLoading = true
          followPublicClient({ clientid: this.clientDetail.cid, userid: this.user.dUserid }).then(response => {
            this.followEditLoading = false
            this.$message({
              type: 'success',
              message: '客户已加入我的客户列表'
            })
            this.viewVisible = false
            this.getData()
          }).catch(() => {
            this.followEditLoading = false
          })
        }).catch(() => {})
      }
    },
    putSeas() {
      if (!this.followEditLoading) {
        this.$confirm('将此客户放回公海, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.followEditLoading = true
          putPublicClientToSeas({ cid: this.clientDetail.cid, userid: this.user.dUserid }).then(response => {
            this.followEditLoading = false
            this.$message({
              type: 'success',
              message: '客户已放回公海'
            })
            this.viewVisible = false
            this.getData()
          }).catch(() => {
            this.followEditLoading = false
          })
        }).catch(() => {})
      }
    },
    forwardC(u) {
      this.$confirm('确认将客户“' + this.clientDetail.name + '”移交给 ' + u.dName + ' 吗?', '移交客户', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        forwardClient({
          cid: this.clientDetail.cid,
          operuserid: this.user.dUserid,
          userid: u.dUserid
        }).then(response => {
          this.$message({
            message: `客户已移交给${u.dName}`,
            type: 'success'
          })
          this.viewVisible = false
          this.getData()
        }).catch(() => {})
      }).catch(() => {})
    },
    getFollowList() {
      this.followLoading = true
      getClentFollowList({ cid: this.clientDetail.cid }).then(response => {
        this.followLoading = false
        let _followList = response.data
        for (let t of _followList) {
          let _imgurlarr = []
          t.time = formatDate(Date.parse(t.time))
          for (const i of t.imglst) {
            _imgurlarr.push(i.imgurl)
          }
          t.imgurlarr = _imgurlarr
        }
        this.followList = _followList
      }).catch(() => {
        this.followLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.gh-container {
  .group-container{
    width: 100%;
    position: relative;
    padding: 20px;
    .group-item{
      position: relative;
      padding: 9px 15px;
      background: #FFF;
      border: 1px dashed #DCDFE6;
      border-radius: 4px;
      display: inline-block;
      color: #606266;
      font-size: 12px;
      font-weight: 500;
      margin:0 20px 20px 0;
      .group-del{
        padding: 2px!important;
        font-size: 10px!important;
        position: absolute;
        right: -10px;
        top: -6px;
      }
    }
  }
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: absolute;
            right: 0;
            top: 4px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 30px;
              line-height: 30px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 30px;
              width: 40px;
              line-height: 30px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .client-list{
            width: 100%;
            position: relative;
            &:after{
              content: ' ';
              display: table;
              clear: both;
            }
            .client-item{
              width: 307px;
              float: left;
              margin-bottom: 17px;
              margin-right: 17px;
              border-radius: 4px;
              border: 1px solid #ebeef5;
              background-color: #fff;
              overflow: hidden;
              color: #303133;
              position: relative;
              cursor: pointer;
              padding: 5px 15px;
              transition: .3s;
              &:hover{
                box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
              }
              .name{
                padding: 10px 0;
                span{
                  font-size: 14px;
                  font-weight: 500;
                }
                .client-sex{
                  width: 18px!important;
                  height: 18px!important;
                  vertical-align: -4px!important;
                }
                .mark{
                  float: right;
                  .el-dropdown-link{
                    color: #828792;
                  }
                }
              }
              .info-box{
                width: 100%;
                position: relative;
                height: 36px;
                line-height: 36px;
                .label{
                  width: 85px;
                  color: #828792;
                  float: left;
                }
                .txt{
                  width: 190px;
                  float: left;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
.view-box{
  width: 100%;
  position: relative;
  .base-info{
    width: 100%;
    position: relative;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
    .text{
      font-size: 13px;
      .l{
        margin-bottom: 15px;
        .label{
          color: #828792;
          margin-right: 14px;
        }
        .name{
          font-weight: 500;
          font-size: 14px;
        }
        .client-sex{
          width: 18px!important;
          height: 18px!important;
          vertical-align: -4px!important;
        }
        &:last-child{
          margin-bottom: 0;
        }
        &:after{
          content: ' ';
          display: table;
          clear: both;
        }
      }
    }
  }
  .principal{
    width: 100%;
    position: relative;
    margin-top: 20px;
    .tit{
      width: 100%;
      position: relative;
      span{
        font-weight: 500;
      }
    }
  }
  .follow-from{
    width: 100%;
    position: relative;
    border: 1px solid #EBEEF5;
    margin-bottom: 10px;
    border-radius: 4px;
    padding-bottom: 10px;
    .follow-img-box{
      width: 100%;
      position: relative;
      padding: 5px 15px;
    }
    .btn-box{
      border-bottom: 1px solid #EBEEF5;
      width: 100%;
      height: 40px;
      line-height: 40px;
      position: relative;
      padding: 0 15px;
    }
  }
  .follow-list{
    width: 100%;
    position: relative;
    .edit-btn{
      position: absolute;
      right: 15px;
      top: 15px;
      z-index: 1;
    }
    .follow-item{
      width: 100%;
      position: relative;
      border: 1px solid #EBEEF5;
      margin-bottom: 20px;
      border-radius: 4px;
      padding: 15px;
      .follow-userinfo{
        width: 100%;
        position: relative;
        padding-left: 60px;
        .photo{
          position: absolute;
          top: 0;
          left: 0;
        }
        .name{
          font-size: 14px;
          font-weight: 500;
          margin-bottom: 4px;
          padding-top: 4px;
          span{
            font-size: 12px;
            margin-left: 10px;
          }
        }
        .time{
          font-size: 12px;
          color:#999;
        }
      }
      .follow-content{
        padding-top: 15px;
        font-size: 13px;
      }
      .follow-imgs{
        width: 100%;
        position: relative;
        margin-top: 10px;
        .follow-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
  }
  .brand-info{
    margin:6px 0;
    .main-info{
      border-bottom: 1px solid #eee;
      position: relative;
      text-align: center;
    }
    .more-info{
      margin-top: 8px;
      .info-row{
        font-size: 12px;
        line-height: 22px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        text-align: center;
        .title {
          font-size: 16px;
        }
        p {
          margin: 4px 0 !important;
          span{
            color:#99a9bf;
          }
        }
      }
    }
  }
}
</style>
